//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import ExpressionHandler from "@/components/SmartContractDesigner/handlers/Control/ExpressionHandler/ExpressionHandler.vue";
import AQInput from "@/components/Generics/AQInput/AQInput";
import AQButton from "@/components/Generics/AQButton/AQButton";
import AQDialog from "@/components/Generics/AQDialog/AQDialog";
import AQModal from "@/components/Generics/AQModal/AQModal";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQListParameters from "@/components/SmartContractDesigner/SCComponents/AQListParameters.vue";

export default {
    name: "CallHandler",
    components: {
        ExpressionHandler,
        AQInput,
        AQButton,
        AQDropdown,
        AQModal,
        AQListParameters,
        AQDialog

    },
    data() {
        return {
            noSCErr: false,
            noFncErr: false,
            contract: null,
            func: null,
            functionModal: false,
            functionData: null,
            functionDataMap: null,
            disabled: false,
            requestNoMap: false,
            dialogOpen: false,
            tab: "details",
            messageTitle: this.$t("smartContract.confirmationDialog.msg2"),
            titleDialog: this.$t("smartContract.confirmationDialog.title"),
            disableFunction: true,
            disabledModal: true
        };
    },

    computed: {
        ...mapGetters("smartContractDesigner", ["selectedPluginData", "getContractSameNetwork"]),
        ddlSelectContract() {
            return {
                options: this.contractsForDdl,
                fitParentContainer: true,
                closeOnSelection: true,
                errorLabel: this.$t("errorRequired")
            };
        },
        ddlSelectFunction() {
            return {
                options: this.functionsForDdl,
                disable: this.disableFunction,
                hideCheckbox: true,
                closeOnSelection: true,
                errorLabel: this.$t("errorRequired")
            };
        },

        contractsForDdl() {
            let contracts = [];
            if (this.getContractSameNetwork) {
                contracts = this.getContractSameNetwork.map(contract => ({
                    value: contract.id,
                    label: contract.name
                }));
            }
            return contracts;
        },
        functionsForDdl() {
            let functions = [];
            if (this.getContractSameNetwork && (this.contract || this.selectedPluginData)) {
                const contractId = this.contract && this.contract.length ? this.contract : this.selectedPluginData.contractId;
                const contractSelected = this.getContractSameNetwork.find(el => el.id === contractId);
                if (contractSelected && contractSelected.functionSignatureDtoList) {
                    functions = contractSelected.functionSignatureDtoList.map(fct => ({
                        value: fct.id,
                        label: fct.name
                    }));
                }
            }
            return functions;
        },

        saveBtn() {
            return { label: this.$t("smartContract.callHandler.save"), disabled: this.disabled };
        }
    },

    watch: {
        selectedPluginData: {
            handler(newVal) {
                if (newVal) {
                    this.selectPlugin(newVal);
                }
            }
        }
    },

    mounted() {
        this.selectPlugin();
    },

    created() {
        this.$root.$on("disabledFunction", value => {
            this.disabled = value;
        });
    },

    methods: {
        ...mapActions("smartContractDesigner", ["getFunctionById"]),
        selectContract(evt) {
            const contractId = evt && evt.length ? evt : null;
            this.selectedPluginData.contractId = contractId;
            const findContract = this.contractsForDdl.find(el => el.value === contractId);
            if (findContract && findContract.label) {
                this.selectedPluginData.contractName = findContract.label;
                this.selectedPluginData.contractId = findContract.value;
                this.disableFunction = false;
            }
            this.$refs.function.clearValue();
            this.disabledModal = true;
        },
        selectFunction(evt) {
            const funcId = evt && evt.length ? evt : null;
            const findFunction = this.functionsForDdl.find(el => el.value === funcId);
            if (findFunction && findFunction.value) {
                this.functionData = findFunction;
                this.selectedPluginData.functionName = findFunction.label;
                this.selectedPluginData.functionId = findFunction.value;
                this.disabledModal = false;
            }
        },
        openModalFunction() {
            if (this.functionData || this.selectedPluginData.functionId) {
                this.getFunctionById(this.func).then(data => {
                    this.functionData = data;
                    this.functionDataMap = this.selectedPluginData;
                    this.functionModal = true;
                });
            }
            this.disabled = true;
        },

        action(type) {
            if (type === "primary") {
                this.requestNoMap = false;
                this.selectedPluginData.request = this.prepareRequestResponse(this.functionData.inParameters, "request");
                this.selectedPluginData.response = this.prepareRequestResponse(this.functionData.outParameters, "response");
                if (this.requestNoMap) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("smartContract.callHandler.saveWarning"),
                        timeout: 1000
                    });
                }
                this.functionModal = false;
            } else if (type === "close") {
                if (!this.disabled) {
                    this.dialogOpen = true;
                } else {
                    this.functionModal = false;
                }
            }
        },

        prepareRequestResponse(value, param) {
            const array = [];
            for (let i = 0; i < value.length; i++) {
                const obj = {
                    index: i,
                    parameterId: value[i].id,
                    type: "DECLARE_ELEMENT",
                    variableName: value[i].variableName,
                    variableValue: value[i].variableName && value[i].variableValue ? value[i].variableValue : value[i].variableName
                };
                if (param === "request" && !obj.variableName) {
                    this.requestNoMap = true;
                }
                array.push(obj);
            }
            return array;
        },

        selectPlugin(val) {
            this.$refs.contract.clearValue();
            this.$refs.function.clearValue();
            const selectData = val || this.selectedPluginData;
            if (selectData.functionId) {
                this.func = selectData.functionId;
                this.disableFunction = false;
                this.disabledModal = false;
            } else {
                this.disableFunction = true;
                this.disabledModal = true;
            }
            if (selectData.contractId) {
                this.contract = selectData.contractId;
            }
            if (selectData.description) {
                this.description = selectData.description;
            }
        }

    }
};
